<template>
	<div>
		<div :class="all">
			<div :class="styletop" v-if="topshow">
				{{titletop}}
			</div>
			<div :class="stylebot">
				{{title}}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			topshow: [Boolean],
			title: [String, Array, Object],
			titletop: [String, Array, Object],
			stylebot: [String, Array, Object],
			styletop: [String, Array, Object],
			all: [String, Array, Object]
		},
	}
</script>

<style>
</style>
